import { render } from "./PanelRightDRC.vue?vue&type=template&id=34c1f3b5&scoped=true&ts=true"
import script from "./PanelRightDRC.vue?vue&type=script&lang=ts"
export * from "./PanelRightDRC.vue?vue&type=script&lang=ts"

import "./PanelRightDRC.vue?vue&type=style&index=0&id=34c1f3b5&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c1f3b5"]])

export default __exports__